import React from 'react';
import { Delete } from 'lucide-react';

interface NumpadGridProps {
  onNumpadPress: (key: string) => void;
}

export const NumpadGrid: React.FC<NumpadGridProps> = ({ onNumpadPress }) => {
  return (
    <div className="numpad-grid">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 'CLR', 0, 'DEL'].map((num) => (
        <button
          key={num.toString()}
          onClick={() => onNumpadPress(num.toString())}
          className={`numpad-btn ${num === 'CLR' ? 'numpad-btn-clr' : ''}`}
        >
          {num === 'DEL' ? <Delete className="w-8 h-8" /> : num}
        </button>
      ))}
    </div>
  );
};
